<template>
  <div class="rt-steps">
    <div
      v-for="(item, index) in stepOptions"
      :class="{ isfinished: index <= currentIndex }"
      :key="index"
      class="rt-step"
    >
      <rt-icon
        v-if="index < currentIndex"
        size="14"
        color="#1890FF"
        name="rt-base-check-circle"
      ></rt-icon>
      <rt-icon
        v-else-if="index == currentIndex"
        size="14"
        color="#1890FF"
        name="rt-base-current"
      ></rt-icon>
      <rt-icon
        v-else
        size="14"
        color="#A9C2E8"
        name="rt-base-circle-line"
      ></rt-icon>
      <span class="step-content">{{ item.Text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtSteps',
  props: {
    stepType: {
      //步骤条类型 1：绑定picklist字段 2：自定义值
      type: Number,
      default: 1,
      required: true
    },
    entity: {
      //实体名
      type: String,
      default: '',
      required: false
    },
    attribute: {
      //字段名
      type: String,
      default: '',
      required: false
    },
    value: {
      //当前值
      type: String,
      default: '',
      required: false
    },
    options: {
      //自定义时 直接传options值过来
      type: Array,
      default: () => [],
      required: false
    }
  },
  data() {
    return {
      stepOptions: [],
      currentIndex: 0 //当前选择索引
    };
  },
  watch: {},
  mounted: function() {
    if (this.stepType == 1) {
      this.bindPicklist();
    } else {
      this.stepOptions = this.options;
      this.getCurrentIndex();
    }
  },
  methods: {
    bindPicklist() {
      let { params, entity, attribute } = this;
      params = Object.assign({}, params, { entity, attribute });
      this.$picklist
        .getPicklistData(params)
        .then(res => {
          this.stepOptions = res;
          this.getCurrentIndex();
        })
        .catch(error => {
          rt.showErrorToast(error.message);
        });
    },
    getCurrentIndex() {
      if (this.stepOptions.length == 0) return;
      for (let i in this.stepOptions) {
        if (this.stepOptions[i].Value == this.value) {
          this.currentIndex = i;
        }
      }
    }
  }
};
</script>
<style scoped>
.rt-steps {
  background: #fff;
  height: 36px;
  display: flex;
  padding: 24px;
  /* border: 1px solid #f4f7f9; */
}
.rt-step {
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0 8px 16px;
  margin-right: 32px;
  font-size: 16px;
  color: #a9c2e8;
}
.step-content {
  margin-left: 8px;
}

.rt-step:after {
  content: ' ';
  position: relative;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-left-width: 0;
  right: -27px;
  border-top: 18px solid transparent;
  border-left: 24px solid #f5f7fa;
  border-bottom: 18px solid transparent;
  border-right-color: #fff;
}

.nofirst {
  padding-left: 16px;
}
.isfinished {
  background: #e6f1fd;
  color: #1890ff;
  font-size: 16px;
}
.rt-step.isfinished:after {
  border-left: 24px solid #e6f1fd;
}
.nofirst:before {
  content: ' ';
  position: relative;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-left-width: 0;
  right: 16px;
  border-top: 18px solid transparent;
  border-left: 24px solid #fff;
  border-bottom: 18px solid transparent;
  border-right-color: transparent;
}
</style>



// WEBPACK FOOTER //
// main.vue?ee2970e6